import { ChevronDown } from "lucide-react";
import type { ReactNode } from "react";

interface Props {
  value: string;
  onChange: (value: string) => void;
  options: readonly { value: string; label: string }[];
  label: string;
  className?: string;
  icon?: ReactNode;
}

/** A native `<select>` on regular glass (the design has no custom dropdown; native keeps a11y free). */
export function GlassSelect({ value, onChange, options, label, className }: Props) {
  return (
    <div className={["glass-select ds-glass", className].filter(Boolean).join(" ")}>
      <select aria-label={label} value={value} onChange={(e) => onChange(e.target.value)}>
        {options.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
      <ChevronDown className="glass-select__chevron" aria-hidden="true" strokeWidth={1.75} />
    </div>
  );
}
